export const permissions = {
    usrRequest: 'perm:user:request',
    usrRequestManage: 'perm:user:request:manage',
    prjCreate: 'perm:project:create',
    prjListUsers: 'perm:project:list:users',
    prjUpdateUserPerm: 'perm:project:update:user:perm',
    prjAddUser: 'prj_add_user',
    usageReport: 'perm:usage:report',
    prjRemove: 'perm:project:remove',
    wfList: 'perm:workflow:list',
    wfCreate: 'perm:workflow:create',
    wfUpdate: 'perm:workflow:update',
    wfRemove: 'perm:workflow:remove',
    wfexeList: 'perm:workflow:execution:list',
    wfexeCreate: 'perm:workflow:execution:create',
    wfexeRead: 'wfexe_read',
    dataCreate: 'perm:data:create',
    dataList: 'perm:data:list',
    dataUpdate: 'perm:data:update',
    dataDownload: 'perm:data:download',
    dataUpload: 'perm:data:upload',
    dataStage: 'perm:data:stage',
    dataRemove: 'perm:data:remove',
    dataPublish: 'perm:data:publish',
    resAsign: 'res_asign',
    resList: 'perm:resource:list',
    resRemove: 'perm:resource:remove',
    resCreate: 'perm:resource:create',
    resUpdate: 'perm:resource:update',
    resAssignmentResAssignment: 'res_assignment_res_assignment',
    prjtagCreate: 'perm:project:tag:create',
    prjtagList: 'perm:project:tag:list',
    prjtagUpdate: 'perm:project:tag:update',
    prjtagRemove: 'perm:project:tag:remove',
    prjUserAssignment: 'perm:project:user:assignment',
    prjPrjtagAssignment: 'perm:project:project:tag:assignment',
    prjResAssignment: 'perm:project:resource:assignment',
    prjResUnassignment: 'perm:project:resource:unassignment',
    prjResRequest: 'perm:project:resource:request',
    prjList: 'perm:project:list',
    prjUpdate: 'perm:project:update',
    locCreate: 'perm:location:create',
    locList: 'perm:location:list',
    locUpdate: 'perm:location:update',
    locRemove: 'perm:location:remove',
    providerCreate: 'perm:provider:create',
    providerList: 'perm:provider:list',
    providerUpdate: 'perm:provider:update',
    providerRemove: 'perm:provider:remove',
    wfexeDetail: 'perm:workflow:execution:detail',
    assignedResList: 'perm:assigned:resource:list',
    assignedResCreate: 'perm:assigned:resource:create',
    assignedResUpdate: 'perm:assigned:resource:update',
    assignedResRemove: 'perm:assigned:resource:remove',
    roleCreate: 'perm:role:create',
    roleUpdate: 'perm:role:update',
    roleRemove: 'perm:role:remove',
    roleList: 'perm:role:list',
    platformadminList: 'platformadmin_list',
    platformadmin: 'perm:platformadmin',
    serviceAccess: 'service_access',
};

export const platformAdminRoleName = 'Admin';
export const platformUserRoleName = 'User';
export const projectOwnerRoleName = 'Owner';
export const projectManagerRoleName = 'Manager';
export const projectMemberRoleName = 'Member';
export const dataPublisherRoleName = 'DataPublisher';
export const jobscriptAccessMemberRoleName = 'JobscriptAccessMember';
export const jobscriptOperatorRoleName = 'JobscriptOperator';
export const jobscriptWriterRoleName = 'JobscriptWriter';
export const providerAdminRoleName = 'ProviderAdmin';
